import React from "react";
import { FormikProps, getIn } from "formik";
import "./form-inputs.style.scss";

interface FieldWrapperProps<Values extends object> {
	label: string;
	// A plain string rather than `keyof Values & string`: the latter makes
	// generic inference for `Values` unreliable across JSX prop order (a
	// keyof-position can't be inverted to recover Values), so this uses
	// Formik's own getIn (the same dynamic-path lookup <Field>/<ErrorMessage>
	// use internally) instead of indexing formik.errors directly.
	name: string;
	formik: FormikProps<Values>;
	children: React.ReactNode;
	id?: string;
}

export default function FieldWrapper<Values extends object>({
	label,
	name,
	formik,
	children,
	id,
}: FieldWrapperProps<Values>) {
	const error = getIn(formik.errors, name);
	const touched = getIn(formik.touched, name);
	const showError = (formik.submitCount > 0 || !!touched) && typeof error === "string";

	return (
		<div className="input-item">
			<label htmlFor={id} className="input-label">{label}</label>
			{children}
			{showError && (
				<div className="validation-error">{error}</div>
			)}
		</div>
	);
}
